// extracted by mini-css-extract-plugin
export default {"root":"IconFavorite_root__kC5oK"};